<div class="slidecontainer">
    <input type="range" [min]="min" [max]="max" [value]="value" [step]="step" class="slider" #rangeSlider [(ngModel)]="value" (ngModelChange)="valueChanged()">
    <span class="label labelBefore" #labelBefore [hidden]="!labelInSelected"><span class="labelInner">{{formattedValue}}</span></span>
    <span class="label labelAfter dark" #labelAfter [hidden]="labelInSelected"><span class="labelInner">{{formattedValue}}</span></span>
</div>